import axios from '../script/axiosAMS'

export default {
  getCharge (params, resultCallback) {
    axios.requestWith({
      url: '/api/charge',
      method: 'get',
      params: params,
      resultCallback: resultCallback
    })
  },
  charge (method, data, resultCallback) {
    axios.requestWith({
      url: '/api/charge',
      method: method,
      data: data,
      resultCallback: resultCallback
    })
  }
}



// WEBPACK FOOTER //
// ./src/script/chargeFiles.js